export default {
  common: {
    or: 'OU',
    showDetails: 'Voir les détails',
    hideDetails: 'Masquer les détails',
    tagline: 'Plateforme professionnelle de gestion vidéo',
    rightsReserved: 'Tous droits réservés'
  },
  login: {
    title: 'Connexion',
    email: 'Email',
    password: 'Mot de passe',
    rememberMe: 'Se souvenir de moi',
    forgotPassword: 'Mot de passe oublié ?',
    submit: 'Se connecter',
    google: 'Se connecter avec Google',
    noAccount: "Vous n'avez pas de compte ?",
    register: "S'inscrire",
    emailVerified: 'Email vérifié avec succès ! Vous pouvez maintenant vous connecter.'
  },
  register: {
    title: 'Créer un compte',
    name: 'Nom complet',
    email: 'Email',
    password: 'Mot de passe',
    passwordConfirm: 'Confirmer le mot de passe',
    terms: {
      accept: "J'accepte les",
      link: "Conditions d'utilisation"
    },
    submit: 'Créer un compte',
    google: "S'inscrire avec Google",
    hasAccount: 'Vous avez déjà un compte ?',
    login: 'Se connecter'
  },
  forgotPassword: {
    title: 'Mot de passe oublié',
    description: 'Entrez votre adresse email et nous vous enverrons un code pour réinitialiser votre mot de passe.',
    email: 'Email',
    submit: 'Envoyer le code',
    success: {
      title: 'Email envoyé',
      message: 'Nous avons envoyé un code de réinitialisation à {email}'
    },
    backToLogin: 'Retour à la connexion',
    remember: 'Vous vous souvenez de votre mot de passe ?',
    login: 'Se connecter',
    enterCode: 'Entrer le code'
  },
  resetPassword: {
    title: 'Réinitialiser le mot de passe',
    description: 'Entrez votre nouveau mot de passe ci-dessous.',
    descriptionWithCode: 'Entrez le code à 6 chiffres envoyé à {email} et votre nouveau mot de passe.',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    submit: 'Réinitialiser',
    success: {
      title: 'Mot de passe réinitialisé',
      message: 'Votre mot de passe a été réinitialisé avec succès.'
    },
    login: 'Se connecter',
    invalidToken: 'Lien invalide ou expiré ?',
    invalidCode: 'Code invalide ou expiré ?',
    requestNew: 'Demander un nouveau code',
    codeLabel: 'Entrez le code de réinitialisation'
  },
  emailVerification: {
    title: 'Vérifiez votre email',
    description: 'Nous avons envoyé un code de vérification à 6 chiffres à {email}',
    verify: 'Vérifier l\'email',
    noCode: 'Vous n\'avez pas reçu le code ?',
    resend: 'Renvoyer le code',
    resendIn: 'Renvoyer dans {seconds}s',
    codeSent: 'Code de vérification envoyé !',
    success: 'Email vérifié avec succès !',
    successAutoLogin: 'Email vérifié avec succès ! Connexion en cours...',
    backToLogin: 'Retour à la connexion',
    changeEmail: 'Changer l\'email',
    otpLabel: 'Entrez le code de vérification'
  },
  organizationSetup: {
    title: 'Configurez votre organisation',
    description: 'Créez votre organisation pour commencer à gérer votre contenu vidéo',
    organizationName: 'Nom de l\'organisation',
    organizationNamePlaceholder: 'Mon Entreprise',
    organizationSlug: 'URL de l\'organisation',
    organizationSlugPlaceholder: 'mon-entreprise',
    slugHint: 'Votre organisation sera accessible à : videas.app/{slug}',
    submit: 'Créer l\'organisation',
    info: 'Vous pourrez inviter des membres et configurer les paramètres après avoir créé votre organisation.',
    success: 'Organisation créée avec succès !'
  },
  validation: {
    nameRequired: 'Le nom est requis',
    emailRequired: "L'email est requis",
    emailInvalid: 'Veuillez entrer un email valide',
    passwordRequired: 'Le mot de passe est requis',
    passwordMin: 'Le mot de passe doit contenir au moins {min} caractères',
    passwordMinLength: 'Au moins {min} caractères',
    passwordUppercase: 'Au moins une lettre majuscule',
    passwordLowercase: 'Au moins une lettre minuscule',
    passwordNumber: 'Au moins un chiffre',
    passwordSpecial: 'Au moins un caractère spécial',
    passwordConfirmRequired: 'Veuillez confirmer votre mot de passe',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    termsRequired: "Vous devez accepter les conditions d'utilisation",
    otpRequired: 'Le code de vérification est requis',
    otpLength: 'Le code doit contenir 6 chiffres',
    otpInvalid: 'Code de vérification invalide',
    codeRequired: 'Le code de réinitialisation est requis',
    codeLength: 'Le code doit contenir 6 caractères',
    strengthVeryWeak: 'Très faible',
    strengthWeak: 'Faible',
    strengthFair: 'Moyen',
    strengthGood: 'Bon',
    strengthStrong: 'Fort',
    invalid: 'Valeur invalide',
    organizationNameRequired: 'Le nom de l\'organisation est requis',
    organizationNameMinLength: 'Le nom de l\'organisation doit contenir au moins {min} caractères',
    organizationSlugRequired: 'L\'URL de l\'organisation est requise',
    organizationSlugInvalid: 'L\'URL ne peut contenir que des lettres minuscules, des chiffres et des tirets',
    organizationSlugMinLength: 'L\'URL doit contenir au moins {min} caractères'
  },
  errors: {
    loginFailed: 'L\'email ou le mot de passe saisi est incorrect. Veuillez réessayer.',
    googleFailed: 'La connexion Google a échoué',
    registerFailed: "L'inscription a échoué. Veuillez réessayer.",
    forgotPasswordFailed: "L'envoi de l'email a échoué. Veuillez réessayer.",
    resetPasswordFailed: 'La réinitialisation a échoué. Veuillez réessayer.',
    invalidToken: 'Jeton invalide ou expiré',
    networkError: 'Erreur réseau. Vérifiez votre connexion.',
    serverError: 'Erreur serveur. Veuillez réessayer plus tard.',
    verificationFailed: 'Code de vérification invalide ou expiré',
    resendFailed: 'Échec de renvoi du code. Veuillez réessayer.',
    organizationSetupFailed: 'Échec de création de l\'organisation. Veuillez réessayer.',
    missingEmailUid: 'Le lien de vérification est invalide. Veuillez vous inscrire à nouveau.',
    missingEmail: 'L\'adresse email est requise. Veuillez recommencer le processus de réinitialisation.'
  }
}